import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const retailerFundedMarketingAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.RetailerFundedMarketingRetailerFundedMarketingViewAccess,
      Permission.RetailerFundedMarketingRetailerFundedMarketingModifyAccess,
    ],
    restrictedBannersAllowed: false,
  },
]
